import throttle from "./../utils/throttle";

export default class TabView {
	constructor(elem, APP) {
		this.elem = elem;
		this.tabs = this.elem.querySelectorAll(".js-tab");
		this.sections = this.elem.querySelectorAll(".js-tab-contents");

		// data-breakpoint: define where the layout changes. should be consistent with css.
		this.breakpoint = this.elem.hasAttribute("data-breakpoint")
			? this.elem.getAttribute("data-breakpoint")
			: "960px";
		this.mobileQuery = `(max-width: ${this.breakpoint})`;

		// data-singleView: generally speaking, true for desktop, false for mobile
		this.singleView = this.elem.hasAttribute("data-singleview")
			? this.elem.getAttribute("data-singleview")
			: true;

		// But if we need it to stay single-view even on mobile, we can pass this as true	
		this.forceSingle = this.elem.hasAttribute('data-force-single')
			? this.elem.getAttribute('data-force-single')
			: false;

		// data-allow-close-all: set to false to require one item open at all times (eg tabs)
		this.allowCloseAll = this.elem.hasAttribute('data-allow-close-all')
			? this.elem.getAttribute('data-allow-close-all')
			: true;
		this.selectAction = (this.allowCloseAll === true) ? 'toggle' : 'add';

		// track the most recent view shown, for continuity when resizing
		this.lastOpenedIndex = -1;
	}

	// Small viewports always behave as if singleview is false
	// Check before acting in case of resizes
	checkMedia() {
		if (this.forceSingle) {
			this.singleView = true;
			return;
		}
		if (window.matchMedia(this.mobileQuery).matches) {
			this.singleView = false;
		} else {
			this.singleView = this.elem.hasAttribute("data-singleview")
				? this.elem.getAttribute("data-singleview")
				: true;
		}
	}

	resetAll() {
		this.tabs.forEach((tab) => tab.classList.remove("is-active"));
		this.sections.forEach((section) => section.classList.remove("is-active"));
	}

	setActive(index) {
		this.lastOpenedIndex = index;
		if (this.singleView === true) {
			this.tabs.forEach((tab, i) => {
				let action = i === index ? this.selectAction : "remove";
				tab.classList[action]("is-active");
			});
		} else {
			this.tabs[index].classList[this.selectAction]("is-active");
		}
	}

	revealTab(index) {
		if (this.singleView === true) {
			this.sections.forEach((section, i) => {
				let action = i === index ? this.selectAction : "remove";
				section.classList[action]("is-active");

				if (i === index) {
					section.focus();
				}
			});
		} else {
			this.sections[index].classList[this.selectAction]("is-active");
		}
	}

	// Closes other opened tabs when expanding browser, leaves most recent one active
	onResize() {
		this.checkMedia();
		if (this.singleView) {
			this.resetAll();
			this.setActive(this.lastOpenedIndex);
			this.revealTab(this.lastOpenedIndex);
		}
	}

	init() {
		this.sections.forEach((section, i) => {
			section.tabIndex = -1;
			if (section.classList.contains('is-active')) {
				this.lastOpenedIndex = i;
			}
		});

		this.elem.addEventListener("click", (e) => {
			let index = [...this.tabs].indexOf(e.target);
			if (index > -1) {
				e.preventDefault();
				this.checkMedia();
				this.revealTab(index);
				this.setActive(index);
			}
		});


		window.addEventListener("resize", () => throttle(this.onResize(), 400));
	}
}
